/**
 * Card / wallet acceptance marks shown on a payment method, referenced by key
 * from `logos: [...]` in src/config/payment.js. Inline SVG so they ship in the
 * bundle (no extra requests, no third-party CDN) and stay crisp at any zoom.
 *
 * Each chip is role="img" with a text label, so screen readers announce
 * "Visa, Mastercard, Apple Pay, Google Pay" rather than nothing.
 */

// Official Visa blue from the current (2021–present) brand mark.
const VISA_BLUE = '#1434cb';

export const PAYMENT_LOGOS = {
  visa: {
    label: 'Visa',
    // Official Visa wordmark, 2021–present. Geometry only — the source file's
    // editor metadata is stripped. Aspect ratio ~3.08:1.
    html: `<svg viewBox="0 0 1000 324.68" width="37" height="12" aria-hidden="true"><path fill="${VISA_BLUE}"
      d="m651.19.5c-70.93,0-134.32,36.77-134.32,104.69,0,77.9,112.42,83.28,112.42,122.42,0,16.48-18.88,31.23-51.14,31.23-45.77,0-79.98-20.61-79.98-20.61l-14.64,68.55s39.41,17.41,91.73,17.41c77.55,0,138.58-38.57,138.58-107.66,0-82.32-112.89-87.54-112.89-123.86,0-12.91,15.5-27.05,47.66-27.05,36.29,0,65.89,14.99,65.89,14.99l14.33-66.2S696.61.5,651.18.5h0ZM2.22,5.5L.5,15.49s29.84,5.46,56.72,16.36c34.61,12.49,37.07,19.77,42.9,42.35l63.51,244.83h85.14L379.93,5.5h-84.94l-84.28,213.17-34.39-180.7c-3.15-20.68-19.13-32.48-38.68-32.48,0,0-135.41,0-135.41,0Zm411.87,0l-66.63,313.53h81L494.85,5.5h-80.76Zm451.76,0c-19.53,0-29.88,10.46-37.47,28.73l-118.67,284.8h84.94l16.43-47.47h103.48l9.99,47.47h74.95L934.12,5.5h-68.27Zm11.05,84.71l25.18,117.65h-67.45l42.28-117.65h0Z"/></svg>`,
  },
  mastercard: {
    label: 'Mastercard',
    html: `<svg viewBox="0 0 38 24" width="32" height="20" aria-hidden="true">
      <defs><clipPath id="wm-mc-clip"><circle cx="13" cy="12" r="10"/></clipPath></defs>
      <circle cx="13" cy="12" r="10" fill="#EB001B"/>
      <circle cx="25" cy="12" r="10" fill="#F79E1B"/>
      <circle cx="25" cy="12" r="10" fill="#FF5F00" clip-path="url(#wm-mc-clip)"/></svg>`,
  },
  applepay: {
    label: 'Apple Pay',
    html: `<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="#000"
      d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/></svg>
      <span class="pay-logo-word">Pay</span>`,
  },
  googlepay: {
    label: 'Google Pay',
    html: `<svg viewBox="0 0 48 48" width="14" height="14" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
      <span class="pay-logo-word pay-logo-word-g">Pay</span>`,
  },
};
